import { render, staticRenderFns } from "./editproductProModel.vue?vue&type=template&id=6b3734d8"
import script from "./editproductProModel.vue?vue&type=script&lang=js"
export * from "./editproductProModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports